import BusinessIcon from "@mui/icons-material/Business";
import InfoIcon from "@mui/icons-material/Info";
import { Box, Divider, Link, Typography } from "@mui/material";
import React from "react";

export default function AboutPage() {
  return (
    <Box sx={{ p: 4, width: "100%", mx: "auto" }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ textAlign: "center", fontWeight: "bold", mb: 2 }}
      >
        About NeuroServ IT Service Desk (ITSD)
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
        sx={{ textAlign: "center", color: "text.secondary" }}
      >
        Version: 0.1.9 | Release Date: 22nd December 2025 | Build ID:
        AXT-0.1.9-1225
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <InfoIcon color="primary" />
        <Typography variant="h6">Product Overview</Typography>
      </Box>
      <Typography variant="body1" gutterBottom>
        NeuroServ is an AI-powered IT service manager platform built to simplify
        IT support, automate service management, and enhance end-user
        experiences across enterprises. It supports Incident, Service Request,
        Tasks, Asset, Knowledge, Reporting, and Administration modules with
        real-time analytics and intelligent automation.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <BusinessIcon color="primary" sx={{ mr: 1 }} />
        <Typography variant="h6">Developed By</Typography>
      </Box>

      <Typography variant="body1" gutterBottom>
        AdaptixTech Pvt. Ltd.
        <br />
        Simplifying IT, Amplifying Intelligence
      </Typography>
      <Typography variant="body1">
        <strong>Website:</strong>{" "}
        <Link href="https://www.adaptixtech.com" target="_blank" rel="noopener">
          www.adaptixtech.com
        </Link>
        <br />
        <strong>Support:</strong>{" "}
        <Link href="mailto:support@adaptixtech.com">
          support@adaptixtech.com
        </Link>
        <br />
        <strong>Phone:</strong>{" "}
        <Link href="tel:+919160870819">+91-9160870819</Link>
      </Typography>

      <Divider sx={{ my: 3 }} />
    </Box>
  );
}
